<mat-card>
  <mat-card-header>
    <mat-card-title>
      <div class="header flex flex-row justify-between items-center">
        <div
          [ngClass]="isMoreActions ? 'header-text-short' : 'header-text-wide'"
          class="flex flex-row gap-[16px]"
        >
          <app-features-container-header
            [header]="header"
            [parentComponentSelector]="parentComponentSelector"
          >
            <ng-content header select="[header]"></ng-content>
          </app-features-container-header>
          <ng-container *ngIf="powerLimitationLabel">
            <div class="flex flex-col items-start">
              <app-pill
                *ngFor="let label of powerLimitationLabel"
                class="flex limitation-labels flex-row justify-center items-center mr-2 mb-2"
                [type]="pillType.primary"
                [matTooltip]="
                  label.isConsumption
                    | booleanSuffix
                      : [
                          '+INSTALLATIONS.INSTALLATION.POWER_LIMITATION.TOOLTIP.GRID_CONSUMPTION_LIMIT',
                          '+INSTALLATIONS.INSTALLATION.POWER_LIMITATION.TOOLTIP.PV_FEED_IN_LIMIT'
                        ]
                    | translate
                      : {
                          value: label | featureLike | value2: featurePropertyKey.value,
                          unit: label | featureLike | unit: featurePropertyKey.value
                        }
                "
              >
                {{ label.label | translate }}
              </app-pill>
            </div>
          </ng-container>
        </div>
        <ng-container *ngIf="isMoreActions">
          <button
            class="not-draggable-link"
            mat-icon-button
            data-at-more-actions
            [matMenuTriggerFor]="moreActionsMenu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </ng-container>
      </div>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-content select="[feature]"></ng-content>
  </mat-card-content>
  <mat-card-actions class="flex flex-row justify-end items-center">
    <a
      *ngIf="overlayType || srcOverlayType"
      (click)="onDetails()"
      data-at-details-and-settings
      class="details-btn not-draggable-link flex flex-row justify-start items-center"
      gtm="onOpen"
      gtmAction="{{ header }} details"
      gtmCategory="installationDetails"
    >
      <ng-container *ngIf="actionButtonName; else defaultName">{{ actionButtonName }}</ng-container>
      <ng-template #defaultName>{{
        '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
      }}</ng-template>
      <mat-icon>keyboard_arrow_right</mat-icon></a
    >
  </mat-card-actions>
</mat-card>

<mat-menu xPosition="before" [overlapTrigger]="false" #moreActionsMenu="matMenu">
  <ng-content select="[more-menu]"></ng-content>
</mat-menu>
